<template>
    <a-drawer title="历史版本" :visible="visible" width="320px" class="plan-history" @close="handleCancel">
        <a-timeline>
            <a-timeline-item v-for="(item, index) in historyList" :key="index">
                <div class="time-content">
                    <p>
                        <span class="version">{{ item.version }}</span>
                    </p>
                    <p>
                        操作人：<span
                            >{{ item.createUser || item.operatorName }}({{ item.phone || item.operatorId }})</span
                        >
                    </p>
                    <p>
                        操作时间：<span>{{ item.createTime }}</span>
                    </p>
                    <p>
                        计划文件：<a class="plan-name" :href="item.content || item.fileUrl">{{ item.fileName }}</a>
                    </p>
                </div>
            </a-timeline-item>
        </a-timeline>
    </a-drawer>
</template>

<script>
import https from '@/utils/http.js';
import * as moment from 'moment';
import { getOperationLogs, getOperationLogsOld } from '../../api';

export default {
    name: 'PlanHistory',
    data() {
        return {
            visible: false,
            historyList: []
        };
    },
    methods: {
        async show(record) {
            this.visible = true;
            const res = await getOperationLogs(record.planCode);
            if (res.length) {
                const list = [];
                res.forEach((item, i) => {
                    list.push({
                        ...item,
                        version: `V${res.length - i}`,
                        createTime: moment(item.createTime).format('YYYY-MM-DD HH:mm:ss'),
                        fileName: `V${res.length - i}_${moment(item.createTime).format('YYYYMMDD')}`
                    });
                });
                this.historyList = list;
            } else {
                const data = await getOperationLogsOld({
                    bizNo: record.planCode,
                    bizTypes: ['PLAN_MSG_LOG']
                });
                const listData = [];
                data.forEach((item, i) => {
                    listData.push({
                        ...item,
                        version: `V${data.length - i}`,
                        createTime: moment(item.createTime).format('YYYY-MM-DD HH:mm:ss'),
                        fileName: `V${data.length - i}_${moment(item.createTime).format('YYYYMMDD')}`
                    });
                });
                this.historyList = listData;
            }
        },
        handleCancel() {
            this.visible = false;
        },
        async downFile(record) {
            await https({
                data: {
                    planCode: record.objectId,
                    planName: record.fileName,
                    url: record.content
                },
                url: '/plan_msg/export',
                service: 'OTMS_WEB_PLUS_SERVER',
                name: `${record.fileName}排线`,
                type: 'xlsx'
            });
        }
    }
};
</script>

<style lang="less" scoped>
.plan-history {
    /deep/ .ant-drawer-header {
        background: #fff;
        border: none;
    }
    /deep/ .ant-drawer-body {
        height: calc(100% - 54px);
        overflow: auto;
        padding-top: 16px;
    }
}
.time-content {
    color: #808792;
    font-size: 14px;
    line-height: 22px;
    p {
        margin-bottom: 8px;
        span {
            color: #000f25;
        }
        .version {
            font-weight: 500;
        }
        .plan-name {
            color: #06b880;
            cursor: pointer;
        }
    }
}
</style>
